import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import PaymentStatsGraphInfo from 'objects/PaymentStatsGraphInfo';
import { CurrencyUtils } from 'PMT/utils';

class PaymentStatsGraph extends Component {

  static propTypes = {
    data: PropTypes.arrayOf(PaymentStatsGraphInfo),
    currencyCode: PropTypes.string,

  };

  componentDidMount() {
    this.updateGraphView();
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.data, prevProps.data)) {
      this.updateGraphView();
    }
  }

  updateGraphView() {
    const data: Array<PaymentStatsGraphInfo> = this.props.data;
    const element = 'payment_stat_graph__placeholder';
    const currencySymbol = CurrencyUtils.getCurrencySymbol(this.props.currencyCode)

    // We must clear the chart before updated it.
    $(`#${element}`).html('');

    Morris.Line({
      element,
      data,
      xkey: 'day',
      ykeys: ['total'],
      // Labels for the ykeys -- will be displayed when you hover over the
      // chart
      labels: [`${I18n.tr('payment_stats.graph.payed_label')} `],
      stacked: true,
      pointSize: 2,
      hideHover: 'auto',
      resize: true,
      lineColors: ['#9dc212'],
      behaveLikeLine: true,
      xLabels: 'day',
      dateFormat: (dateTimestamp: number): string => {
        const date = moment(dateTimestamp);
        // TODO: Localize
        return date.format('DD/MM/Y');
      },
      xLabelFormat: (amount: number): string => {
        if (!_.isUndefined(amount)) {
          // TODO: Localize
          return amount.toLocaleString('fr', { year: 'numeric', month: 'long', day: 'numeric' });
        }
        return '';
      },
      yLabelFormat: (value): string => {
        const y = parseFloat(value);
        if (!_.isNaN(y)) {
          return `${y.toFixed(2)} ${currencySymbol}`;
        }
        return '';
      }
    });
  }

  render() {
    return (
      <div className="payment_stat_graph">
        <h2>{I18n.tr('payment_stats.graph.amount_payed')}</h2>

        <div className="graph_container">
          <div id="payment_stat_graph__placeholder" className="graph_placeholder"></div>
        </div>
      </div>
    );
  }

}

export default PaymentStatsGraph;
